import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAI_Co_ApplicantNamesData = createAsyncThunk(
  "AI_Co_ApplicantNames/GetAI_Co_ApplicantNamesData",
  async (aI_Co_applicantNamesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_Co_ApplicantNames/GetAI_Co_ApplicantNamesData",
        {
          aI_Co_applicantNamesId: aI_Co_applicantNamesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateAI_Co_ApplicantNames = createAsyncThunk(
  "AI_Co_ApplicantNames/ValidateAI_Co_ApplicantNames",
  async (aI_Co_applicantNames, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_Co_ApplicantNames/ValidateAI_Co_ApplicantNames",
        {
          gender: aI_Co_applicantNames.gender,
          phoneNumber: aI_Co_applicantNames.phoneNumber,
          emailAddress: aI_Co_applicantNames.emailAddress,
          proofOfIdentityDocument: aI_Co_applicantNames.proofOfIdentityDocument,
          commissioner: aI_Co_applicantNames.commissioner,
          fourSyllablesName: aI_Co_applicantNames.fourSyllablesName,
  
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
            return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const UpdateAI_Co_ApplicantNamesByEmail = createAsyncThunk(
    "AI_Co_ApplicantNames/UpdateAI_Co_ApplicantNamesByEmail",
    async (aI_Co_applicantNames, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/AI_Co_ApplicantNames/UpdateAI_Co_ApplicantNamesByEmail",
          {
            gender: aI_Co_applicantNames.gender,
            phoneNumber: aI_Co_applicantNames.phoneNumber,
            emailAddress: aI_Co_applicantNames.emailAddress,
            aI_ApplicationInformationId:aI_Co_applicantNames.aI_ApplicationInformationId
          }
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
const AI_Co_ApplicantNamesData = createSlice({
  name: "AI_Co_ApplicantNamesData",
  initialState: {
    AI_Co_ApplicantNamesData: {},
    loadingAI_Co_ApplicantNamesData: false,
    errorAI_Co_ApplicantNamesData: null,

    AI_Co_ApplicantNamesValidate: [],
    loadingAI_Co_ApplicantNamesValidate: false,
    errorAI_Co_ApplicantNamesValidate: null,

    AI_Co_ApplicantNamesUpdate: [],
    loadingAI_Co_ApplicantNamesUpdate: false,
    errorAI_Co_ApplicantNamesUpdate: null,
  },
  reducers: {
    restI_Co_ApplicantNamesDataValidate : (state,action)=>{
      state.AI_Co_ApplicantNamesValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAI_Co_ApplicantNamesData.pending, (state, action) => {
        state.loadingAI_Co_ApplicantNamesData = true;
        state.AI_Co_ApplicantNamesData = action.payload;
        state.errorAI_Co_ApplicantNamesData = null;
      })
      .addCase(GetAI_Co_ApplicantNamesData.fulfilled, (state, action) => {
        state.loadingAI_Co_ApplicantNamesData = false;
        state.AI_Co_ApplicantNamesData = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAI_Co_ApplicantNamesData.rejected, (state, action) => {
        state.loadingAI_Co_ApplicantNamesData = false;
        state.errorAI_Co_ApplicantNamesData = action.payload;
      })

      .addCase(ValidateAI_Co_ApplicantNames.pending, (state, action) => {
        state.loadingAI_Co_ApplicantNamesValidate = true;
        state.AI_Co_ApplicantNamesValidate = action.payload;
        state.errorAI_Co_ApplicantNamesValidate = null;
      })
      .addCase(ValidateAI_Co_ApplicantNames.fulfilled, (state, action) => {
        state.loadingAI_Co_ApplicantNamesValidate = false;
        state.AI_Co_ApplicantNamesValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateAI_Co_ApplicantNames.rejected, (state, action) => {
        state.loadingAI_Co_ApplicantNamesValidate = false;
        state.errorAI_Co_ApplicantNamesValidate = action.payload;
      })

      .addCase(UpdateAI_Co_ApplicantNamesByEmail.pending, (state, action) => {
        state.loadingAI_Co_ApplicantNamesUpdate = true;
        state.AI_Co_ApplicantNamesUpdate = action.payload;
        state.errorAI_Co_ApplicantNamesUpdate = null;
      })
      .addCase(UpdateAI_Co_ApplicantNamesByEmail.fulfilled, (state, action) => {
        state.loadingAI_Co_ApplicantNamesUpdate = false;
        state.AI_Co_ApplicantNamesUpdate = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateAI_Co_ApplicantNamesByEmail.rejected, (state, action) => {
        state.loadingAI_Co_ApplicantNamesUpdate = false;
        state.errorAI_Co_ApplicantNamesUpdate = action.payload;
      });
  },
});
export const { restI_Co_ApplicantNamesDataValidate } = AI_Co_ApplicantNamesData.actions;
export default AI_Co_ApplicantNamesData.reducer;
